export default __webpack_public_path__ + "resources/icons/n242-84a3.webp";